import React from 'react';

const Main = () => {
  return (
    <div>
     <p>Welcome to Entertainment-hub, a platform that provides information about movies and series. Our mission is to make it easy for movie and series lovers to access all the information they need in one place.
<br/><br/>
With Entertainment-hub, you can search for your favorite movies and series and get detailed information such as cast, ratings, IMDb score, and more. Our user-friendly interface displays all the information in a clear and concise manner, making it easier for you to make informed decisions about what to watch.
<br/><br/>
We believe that Entertainment-hub is more than just a movie and series database. It's a community where movie and series fans can come together to share their love for the latest and greatest in the entertainment world. Whether you're a casual movie-goer or a die-hard fan, Entertainment-hub is the perfect place for you to find everything you need to know about the movies and series you love.
<br/><br/>
So why wait? Start exploring Entertainment-hub today and discover the world of movies and series like never before!
      </p>
    </div>
  );
};

export default Main;
